import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import Typography from '@classify/react-core-components/Typography';
import Box from '@classify/react-core-components/Box';
import SearchContext from './SearchContext';
import SearchField from './SearchField';
export default function SearchForm(t0) {
  const $ = _c(13);
  const {
    translations,
    isCompactMode: t1,
    isFieldShown: t2
  } = t0;
  const isCompactMode = t1 === undefined ? false : t1;
  const isFieldShown = t2 === undefined ? false : t2;
  const {
    onQueryChange,
    hasEmptyPeopleList
  } = useContext(SearchContext);
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      position: "relative",
      height: "100%",
      display: "flex",
      alignItems: "center"
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      marginLeft: 8
    };
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== translations.inputSearchLabel) {
    t5 = <Typography sx={t4} component="label" variant="h5" htmlFor="people-search">{translations.inputSearchLabel}</Typography>;
    $[2] = translations.inputSearchLabel;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== hasEmptyPeopleList || $[5] !== isCompactMode || $[6] !== isFieldShown || $[7] !== onQueryChange || $[8] !== translations) {
    t6 = isFieldShown && !hasEmptyPeopleList && <Box style={{
      position: "absolute",
      left: 0,
      right: 0,
      top: 0,
      height: "100%"
    }}><Box sx={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        marginLeft: {
          sm: 8,
          md: "25%"
        },
        marginRight: {
          sm: 2,
          md: "25%"
        },
        maxWidth: {
          md: 704
        }
      }}><SearchField shouldAutoFocus={true} onChange={onQueryChange} data-testid="people-search-input" id="people-search" translations={translations} hasSearchIconHidden={isCompactMode} /></Box></Box>;
    $[4] = hasEmptyPeopleList;
    $[5] = isCompactMode;
    $[6] = isFieldShown;
    $[7] = onQueryChange;
    $[8] = translations;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <form role="search" style={t3}>{t5}{t6}</form>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}